import React from 'react';
import './Services.css';

const ServiceItem = ({ icon, title, description }) => (
  <div className="service-item">
    <div className="service-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const Services = () => {
  const serviceData = [
    {
      icon: '⚙️',
      title: 'Bespoke Software Development',
      description:
        'We design and build custom software solutions from the ground up, tailored precisely to your workflows, your users, and your domain. With deep experience in clinical and operational systems across the New Zealand health and commercial sectors, we deliver web applications, integration APIs, and data platforms that fit the way your teams actually work - not the other way around.',
    },
    {
      icon: '💡',
      title: 'Software Consultancy',
      description:
        'Not sure where to start, or whether your current system is the right fit? We provide independent, pragmatic advice on technology strategy, system architecture, vendor selection, and solution design. We help you cut through the noise so you can make confident decisions - whether you\'re planning a new platform, scaling an existing one, or evaluating a third-party product.',
    },
    {
      icon: '💳',
      title: 'Payment Gateway Solutions',
      description:
        'We design and deliver robust, Java-powered payment gateway integrations for organisations operating at a global scale. From multi-currency transaction flows and international payment exchange to secure API integrations with global payment providers, our engineers bring hands-on fintech experience to help businesses process payments reliably, securely, and at speed - whether you\'re entering new markets or modernising existing payment infrastructure.',
    },
    {
      icon: '🛠️',
      title: 'IT Support',
      description:
        'We provide responsive, reliable IT support for organisations that depend on their systems to run smoothly. From day-to-day helpdesk assistance and user troubleshooting to infrastructure monitoring and incident response, our team keeps things running - and steps in quickly when they don\'t. We tailor support arrangements to your size and needs, with no unnecessary overhead.',
    },
    {
      icon: '📋',
      title: 'IT Project Management',
      description:
        'Delivering technology projects on time and on scope requires more than good intentions. We bring structured project management discipline - clear planning, stakeholder alignment, risk tracking, and delivery governance - to keep your IT initiatives on track from first kick-off to final go-live. Experienced across both agile and waterfall environments, and comfortable working alongside clinical, operational, and vendor teams.',
    },
    {
      icon: '🎓',
      title: 'IT Training & Change Management',
      description:
        'New technology only delivers value when people know how to use it - and want to. We support the human side of digital change: designing and delivering practical user training, building adoption plans, managing stakeholder communications, and helping teams transition confidently to new systems. Particularly experienced in clinical environments where change fatigue is real and trust must be earned.',
    },
  ];

  return (
    <section id="services" className="section services-section">
      <div className="section-content">
        <h1>Our Services</h1>
        <p className="subtitle">What can we help you with?</p>
        <div className="services-grid">
          {serviceData.map((service, index) => (
            <ServiceItem
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
